import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const attachAlipay = createAction(ACTION.ATTACH_ALIPAY.REQUEST, (complaintId, alipayId) => ({complaintId, alipayId}));
export const detachAlipay = createAction(ACTION.DETACH_ALIPAY.REQUEST, (complaintId, alipayId) => ({complaintId, alipayId}));
